import { ReactNode } from "react";

import { Box, Heading, useTheme } from "@seneca/senekit";

export function SignUpWrapper({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        position: "fixed",
        width: "100vw",
        height: "calc(100% - 70px)",
        top: "70px"
      }}
    >
      {children}
    </div>
  );
}

export function SignUpCard({ children }: { children: ReactNode }) {
  const theme = useTheme();

  return (
    <Box
      position="fixed"
      left="50%"
      top="50%"
      transform="translate(-50%, -50%)"
      margin="auto"
      paddingX={["xlarge", "xxlarge"]}
      paddingY="xxlarge"
      maxWidth={["100%", "640px"]}
      maxHeight={["100%", "90%"]}
      width="100%"
      overflowY="auto"
      backgroundColor={theme.foreground}
      height={["100%", "unset"]}
      borderRadius={["none", "12"]}
      display="flex"
      flexDirection="column"
      gap="xxlarge"
    >
      {children}
    </Box>
  );
}

export function SignUpCardContent({
  children: { body, footer }
}: {
  children: {
    body: ReactNode;
    footer: ReactNode;
  };
}) {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box width="100%" marginBottom="xxlarge">
        {body}
      </Box>
      {footer}
    </Box>
  );
}

export function SignUpHeading({ children }: { children: ReactNode }) {
  return (
    <Heading level="3" align="center">
      {children}
    </Heading>
  );
}
